import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['toast']
  static values = {
    duration: { type: Number, default: 3000 }
  }

  toastTargetConnected(element) {
    setTimeout(() => {
      element.remove()
    }, this.durationValue)
  }
}
